import { useChainId } from 'src/hooks/chain';
import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useInventoryMasterDataQuery = () => {
    const chainId = useChainId();
    const { data, loading, error, refetch } = useApiQuery('/api/inventorymanagement/chains/{chainId}', 'get', {
        path: {
            chainId: chainId,
        },
        enabled: !!chainId,
    });

    return { data, loading, error, refetch };
};
